import type { IconProps } from './types';
import './icons.css';

export default function Refresh({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-refresh ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        fill="transparent"
        d="M14.597 9.736c0 2.083-2.762 5.208-6.598 5.208A6.944 6.944 0 1 1 8 1.056c2.848 0 5.179 1.366 6.25 3.819m-3.819.347h4.167V1.056"
      />
    </svg>
  );
}
